"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const lodash_es_1 = require("lodash-es");
const Popover_1 = __importDefault(require("../../hoc/Popover"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const ARROW_CONFIG = { className: styles_module_css_1.default.arrow, width: 5, height: 4, tipRadius: 2 };
const Tooltip = ({ text, children, visible = false, placement = 'top', gap = 5, }) => {
    const tooltipId = (0, lodash_es_1.uniqueId)('tooltip-');
    return ((0, jsx_runtime_1.jsx)(Popover_1.default, { arrow: ARROW_CONFIG, hover: true, visible: visible, placement: placement, gap: gap, content: () => Boolean(text) && ((0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.tooltip, role: "tooltip", id: tooltipId, children: text })), children: ({ ref, props, visible }) => react_1.default.cloneElement(children, {
            ...props,
            ref,
            ...(visible && { 'aria-describedby': tooltipId }),
        }) }));
};
exports.default = Tooltip;
